import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKampanyaForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKampanyaForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  DeleteFromSessionStorage: string;
  DeleteFromSessionStorage_dummy: string;
  CampaignsImageSave: number;
  CampaignsImageSave_dummy: number;
  GoBack: any;
  GoBack_dummy: any;
  CampaignsById: any[];
  CampaignsById_dummy: any[];
  isWeb: boolean;
  isWeb_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
}

export class KampanyaForm_ScreenBase extends React.PureComponent<
  IKampanyaForm_ScreenProps,
  any
> {
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "2facb5a8-c739-4059-9b44-01faf94e3340",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 667938, PropertyName: "label", Value: "Kaydet" },
        { Id: 975665, PropertyName: "value", Value: "Kampanya Tanımlama" },
        {
          Id: 878844,
          PropertyName: "value",
          Value:
            "En iyi görüntüleme için lütfen 2:1 oranında (genişlik:yükseklik) görsel yükleyiniz.",
        },
        { Id: 136858, PropertyName: "label", Value: "Fotoğraf Yükle" },
        { Id: 324251, PropertyName: "label", Value: "Fotoğrafı Sil" },
        { Id: 964660, PropertyName: "value", Value: "Kampanya Adı" },
        {
          Id: 321211,
          PropertyName: "placeholder",
          Value: "Kampanya adını yazın...",
        },
        { Id: 526367, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 206109,
          PropertyName: "startDatePlaceholder",
          Value: "Başlangıç Tarihi",
        },
        {
          Id: 206109,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        { Id: 350544, PropertyName: "value", Value: "Kampanya Kodu" },
        {
          Id: 91424,
          PropertyName: "placeholder",
          Value: "Kampanya kodunu girin...",
        },
        { Id: 18257, PropertyName: "value", Value: "Kampanya İçeriği" },
        {
          Id: 945584,
          PropertyName: "placeholder",
          Value: "Kampanya detaylarını belirtin...",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.kampanyaform_321211_value_kuikaTextInputRef = React.createRef();
    this.kampanyaform_91424_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      DeleteFromSessionStorage: "",
      CampaignsImageSave: 0,
      GoBack: "",
      CampaignsById: [],
      isWeb: false,
      IfThenElse: false,
      SetValueOf: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kampanyaform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KampanyaFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kampanyaform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kampanyaform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KampanyaFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kampanyaform_958544_value:
        this.state.CampaignsById?.at?.(0)?.imageUrl ?? undefined,
      kampanyaform_321211_value:
        this.state.CampaignsById?.at?.(0)?.title ?? undefined,
      kampanyaform_206109_value: {
        startValue: this.state.CampaignsById?.at?.(0)?.startDate ?? undefined,
        endValue: this.state.CampaignsById?.at?.(0)?.endDate ?? undefined,
      },
      kampanyaform_91424_value:
        this.state.CampaignsById?.at?.(0)?.campaignCode ?? undefined,
      kampanyaform_945584_value:
        this.state.CampaignsById?.at?.(0)?.content ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KampanyaFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KampanyaForm/KampanyaFormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CampaignsById = result?.data.campaignsById;
    formVars.kampanyaform_958544_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].imageUrl
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].imageUrl
        : null
    );
    formVars.kampanyaform_321211_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].title
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].title
        : null
    );
    formVars.kampanyaform_206109_startvalue = ReactSystemFunctions.value(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].startDate
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].startDate
        : null
    );
    formVars.kampanyaform_206109_endvalue = ReactSystemFunctions.value(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].endDate
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].endDate
        : null
    );
    formVars.kampanyaform_91424_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].campaignCode
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].campaignCode
        : null
    );
    formVars.kampanyaform_945584_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].content
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].content
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KampanyaFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KampanyaFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kampanyaform_958544_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].imageUrl
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].imageUrl
        : null
    );

    formVars.kampanyaform_321211_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].title
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].title
        : null
    );

    formVars.kampanyaform_206109_value = {
      startValue: ReactSystemFunctions.value(
        this,
        stateVars.CampaignsById !== undefined
          ? stateVars.CampaignsById?.length > 0
            ? stateVars.CampaignsById[0].startDate
            : null
          : this.state.CampaignsById?.length > 0
          ? this.state.CampaignsById[0].startDate
          : null
      ),
      endValue: ReactSystemFunctions.value(
        this,
        stateVars.CampaignsById !== undefined
          ? stateVars.CampaignsById?.length > 0
            ? stateVars.CampaignsById[0].endDate
            : null
          : this.state.CampaignsById?.length > 0
          ? this.state.CampaignsById[0].endDate
          : null
      ),
    };

    formVars.kampanyaform_206109_value = {
      startValue: ReactSystemFunctions.value(
        this,
        stateVars.CampaignsById !== undefined
          ? stateVars.CampaignsById?.length > 0
            ? stateVars.CampaignsById[0].startDate
            : null
          : this.state.CampaignsById?.length > 0
          ? this.state.CampaignsById[0].startDate
          : null
      ),
      endValue: ReactSystemFunctions.value(
        this,
        stateVars.CampaignsById !== undefined
          ? stateVars.CampaignsById?.length > 0
            ? stateVars.CampaignsById[0].endDate
            : null
          : this.state.CampaignsById?.length > 0
          ? this.state.CampaignsById[0].endDate
          : null
      ),
    };

    formVars.kampanyaform_91424_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].campaignCode
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].campaignCode
        : null
    );

    formVars.kampanyaform_945584_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsById !== undefined
        ? stateVars.CampaignsById?.length > 0
          ? stateVars.CampaignsById[0].content
          : null
        : this.state.CampaignsById?.length > 0
        ? this.state.CampaignsById[0].content
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KampanyaFormComponent_667938_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KampanyaFormComponent_667938_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KampanyaFormComponent_667938_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kampanyaform_321211_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CampaignCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kampanyaform_91424_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Content_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kampanyaform_945584_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kampanyaform_206109_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kampanyaform_206109_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kampanyaform_958544_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KampanyaForm/KampanyaFormComponent_667938_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CampaignsImageSave = result?.data.campaignsImageSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KampanyaFormComponent_667938_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KampanyaFormComponent_667938_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KampanyaFormComponent_721758_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KampanyaFormComponent_136858_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isWeb = await ReactSystemFunctions.isWeb();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KampanyaFormComponent_136858_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KampanyaFormComponent_136858_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.KampanyaFormComponent_136858_onClick_if11_,
      "KampanyaForm",
      "FotoDrawer",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "760251",
      null,
      null,
      "true",
      "400px",
      "200px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  KampanyaFormComponent_136858_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kampanyaform_958544_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  KampanyaFormComponent_136858_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.KampanyaFormComponent_136858_onClick_else11_,
      "KampanyaForm",
      "FotoDrawer",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "372291",
      null,
      "bottom",
      "true",
      "100vw",
      "40vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  KampanyaFormComponent_136858_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kampanyaform_958544_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  KampanyaFormComponent_136858_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      )
    ) {
      isErrorOccurred = await this.KampanyaFormComponent_136858_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.KampanyaFormComponent_136858_onClick_else1();
      if (isErrorOccurred) return true;
    }

    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KampanyaFormComponent_324251_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("KampanyaBanner", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kampanyaform_958544_value",
        "string"
      ),
      null,
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KampanyaFormPageInit();
    }
    if (diId == 760251) {
      isErrorOccurred = await this.KampanyaFormComponent_136858_onClick_if11_();
      if (isErrorOccurred) return true;
    } else if (diId == 372291) {
      isErrorOccurred =
        await this.KampanyaFormComponent_136858_onClick_else11_();
      if (isErrorOccurred) return true;
    }
  }
}
